module.exports = __webpack_public_path__ + "img/2.58164d8b.png";